import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetPartner from '@/modules/manage-player/api/hooks/useQueryGetPartner'
import PartnerListing from '@/modules/manage-player/components/Partner/components/PartnerListing'

function PartnerPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		skip: (currentPage - 1) * pageSize,
		take: pageSize,
		nickname: searchQuery || undefined,
	}

	const { data, isLoading } = useQueryGetPartner(payload)

	return (
		<PageContainer>
			<PartnerListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedPartnerPage = withUserPermission(PartnerPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedPartnerPage
